import { once } from 'ramda';

export const generateSessionId = () => `s-${Date.now()}-${Math.round(Math.random() * Math.pow(10, 10))}`;

export const getSessionId = once(() => {
  return window.__SESSION_ID__ || generateSessionId();
});
